<script lang="ts">
  import type { FieldState, InputEvent } from '@shared/lib/types';
  import { Field } from '@shared/ui/fields/field';
  import { Icon } from '@shared/ui/icon';

  import { phoneMask } from '../utils';

  export let placeholder: string;
  export let required = false;
  export let state: FieldState = 'default';
  export let label: string | undefined = undefined;
  export let helperText: string | undefined = undefined;
  export let noMargin = false;
  export let value = '';
  export let nativeInput: HTMLInputElement;

  let country = '';

  function inputHandler(e: InputEvent) {
    state === 'error' && (state = 'default') && (helperText = '');
    value = e.currentTarget.value.trim();
    setPhoneMask();
  }
  function focusHandler() {
    state === 'error' || state === 'success' || (state = 'active');
    setPhoneMask();
  }

  function setCountry(newCountry: string) {
    country = newCountry;
  }
  function setPhoneMask() {
    value = phoneMask(value, setCountry);
  }
</script>

<Field {state} {helperText} {label} {noMargin}>
  <div class="relative">
    <div class="absolute left-4 top-1/2 -translate-y-1/2">
      {#if country}
        {country}
      {:else}
        <Icon name="globe" classes="fill-[transparent]" />
      {/if}
    </div>

    <input
      bind:this="{nativeInput}"
      class="input placeholder-default-500 dark:placeholder-dark-500 w-full bg-transparent py-3 pl-[52px] outline-none {$$props.class}"
      type="tel"
      name="phone"
      {value}
      {required}
      autocomplete="tel"
      placeholder="{placeholder + (required ? '*' : '')}"
      on:focus="{focusHandler}"
      on:input="{inputHandler}"
    />
    <slot />
  </div>
</Field>
